module.exports = __webpack_public_path__ + "static/media/bh.290519a3.svg";